import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/History_of_Sci_&_Tech_-_Development_of_Computers_and_the_Internet.png';

function HistoryPageComputersInternet() {
  return (
    <TopicPage
      topicKey="Development of Computers and the Internet"
      title="History: Development of Computers and the Internet"
      backgroundImage={bg}
      startRoute="/History-Computers-Internet-Go"
      scrollLabels={[
        "Early Computers and Programming",
        "Internet Evolution",
        "Digital Age Impact",
      ]}
      backRoute="/history-host"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageComputersInternet;
